<template>
  <div id="app">
    <CookieConsent />
    <div class="container">
      <h1 v-if="$route.meta.h1Title" style="display: none;" class="page-title">{{ $route.meta.h1Title }}</h1>
      <router-view></router-view>
      <lg-preview></lg-preview>
    </div>
  </div>

</template>
 
<script>
import useaddRoute from "./utils/loadingRouter";
import { mapGetters } from "vuex";
import CookieConsent from "./components/CookieConsent.vue";
export default {
  name: "App",
  components: { CookieConsent },
  data() {
    return {
      
    };
  },
  created() {
    useaddRoute();
  },
  mounted() {
    // 移除自动重定向逻辑，避免干扰路由守卫和meta信息更新
  },
 
  computed: {
    ...mapGetters(["updateNav", "updateStore"]),
  },
 
  methods: {
     isMobile () {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                return true;
            } else {
                return false;
            }
    },
    changeFavicon(src) {
    
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = src;
  }
  },
};
</script>

<style lang="scss">
.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 20px 0;
  text-align: center;
}
</style>